module.exports = __webpack_public_path__ + "img/search-sm.f65c2622.svg";